import { Organization } from './';
import { AWARDS_LATAM } from '../awards/latam';

// Same shape as ./awards.js but built from the LATAM list, and as a copy so
// the shared Organization object is not modified.
export const AwardsLatam = {
  ...Organization,
  awards: AWARDS_LATAM.flatMap((year) =>
    year.awards.map((award) => `${year.year} ${award.name}`)
  ).join(','),
};
